import { PropsSVG } from "./types";

function DarkContactPriceListIcon({
  height = 32,
  width = 32,
  ...props
}: PropsSVG) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2.13867"
        y="20.0625"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        fill="#172C37"
        stroke="white"
        strokeWidth="1.54857"
      />
      <rect
        x="5.23535"
        y="3.41528"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        stroke="white"
        strokeWidth="1.54857"
      />
      <rect
        x="2.13867"
        y="8.83545"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        stroke="white"
        strokeWidth="1.54857"
      />
      <rect
        x="4.46191"
        y="14.2551"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        stroke="white"
        strokeWidth="1.54857"
      />
      <ellipse
        cx="20.9087"
        cy="19.4845"
        rx="9.09132"
        ry="9.10049"
        fill="#01C246"
        stroke="white"
        strokeWidth="1.54857"
      />
      <path
        d="M20.9567 25.4506C20.7269 25.4506 20.5328 25.3696 20.3743 25.2075C20.2159 25.0455 20.1366 24.8429 20.1366 24.5999V23.7005L20.4932 24.0286C19.9623 24.0043 19.5028 23.9355 19.1146 23.822C18.7263 23.7086 18.4094 23.5952 18.1638 23.4817C17.9578 23.3845 17.8112 23.2467 17.724 23.0685C17.6448 22.8902 17.6131 22.7079 17.629 22.5216C17.6527 22.3352 17.7201 22.1651 17.831 22.0111C17.9419 21.8572 18.0845 21.7559 18.2589 21.7073C18.4411 21.6506 18.651 21.6749 18.8887 21.7802C19.0472 21.8693 19.2849 21.9625 19.6018 22.0597C19.9267 22.1489 20.3268 22.1934 20.8022 22.1934C21.135 22.1934 21.3964 22.161 21.5866 22.0962C21.7847 22.0314 21.9233 21.9463 22.0025 21.841C22.0897 21.7275 22.1333 21.606 22.1333 21.4764C22.1333 21.3548 22.1016 21.2535 22.0382 21.1725C21.9827 21.0834 21.8877 21.0064 21.753 20.9416C21.6183 20.8687 21.4321 20.8039 21.1944 20.7471L19.8514 20.4555C19.1146 20.2853 18.5639 20.0017 18.1994 19.6047C17.8429 19.1996 17.6646 18.677 17.6646 18.0369C17.6646 17.5507 17.7795 17.1172 18.0093 16.7364C18.247 16.3475 18.5758 16.0315 18.9957 15.7884C19.4236 15.5454 19.9227 15.3914 20.4932 15.3266L20.1366 15.5332V14.7189C20.1366 14.4758 20.2159 14.2733 20.3743 14.1112C20.5328 13.9492 20.7269 13.8682 20.9567 13.8682C21.1944 13.8682 21.3925 13.9492 21.5509 14.1112C21.7094 14.2733 21.7886 14.4758 21.7886 14.7189V15.5332L21.4321 15.3023C21.7332 15.3104 22.058 15.3631 22.4066 15.4603C22.7552 15.5494 23.0603 15.675 23.3217 15.8371C23.504 15.9343 23.6307 16.068 23.7021 16.2381C23.7813 16.4083 23.809 16.5825 23.7852 16.7607C23.7694 16.9309 23.706 17.0848 23.5951 17.2226C23.4921 17.3603 23.3495 17.4535 23.1672 17.5021C22.9929 17.5426 22.783 17.5102 22.5374 17.4049C22.3551 17.3239 22.1491 17.259 21.9193 17.2104C21.6975 17.1537 21.4123 17.1253 21.0636 17.1253C20.6437 17.1253 20.3189 17.2023 20.0891 17.3563C19.8673 17.5102 19.7563 17.7087 19.7563 17.9518C19.7563 18.1138 19.8197 18.2516 19.9465 18.365C20.0812 18.4704 20.3228 18.5635 20.6714 18.6446L22.0263 18.9484C22.779 19.1185 23.3336 19.4021 23.6902 19.7992C24.0546 20.1881 24.2369 20.6945 24.2369 21.3184C24.2369 21.8045 24.122 22.2339 23.8922 22.6067C23.6624 22.9794 23.3416 23.2832 22.9295 23.5182C22.5255 23.7531 22.054 23.9071 21.5153 23.98L21.7886 23.6883V24.5999C21.7886 24.8429 21.7094 25.0455 21.5509 25.2075C21.4004 25.3696 21.2023 25.4506 20.9567 25.4506Z"
        fill="white"
      />
    </svg>
  );
}

export default DarkContactPriceListIcon;
